import { render } from "./DormantPopup.vue?vue&type=template&id=61db1c57"
import script from "./DormantPopup.vue?vue&type=script&lang=js"
export * from "./DormantPopup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__